import axios from "axios";
import { history, publicRoutes } from "@/routing";
import store from "@/state/store";
import { clearProfile } from "@/state/profileSlice";
import { clearUser } from "@/auth/authSlice";

export const baseURL = `${window.cmai.config.apiURL}api/v0`;

export const instance = axios.create({
  baseURL,
  withCredentials: true,
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.status === 401) {
      console.log("Redirecting to login - API 401 error");
      store.dispatch(clearProfile());
      store.dispatch(clearUser());
      history.push(publicRoutes[0].path);
    }
    if (error.status === 403 && error.response.data.includes("Blocked!")) {
      return Promise.reject({
        message: "Invalid input: Please avoid using numbers and hyphens inside parentheses. Instead, use words or rephrase your entry.",
      });
    }
    if (error.status === 400) {
      return Promise.reject({
        message: "Bad request: Please ensure your input is correct and try again.",
      });
    }
    return Promise.reject(error);
  },
);

const handleResponse = (response) => response.data;

const handleError = (error) => Promise.reject(error.response?.data || error.message);

export const API = {
  get: (url, config) => instance.get(url, config).then(handleResponse, handleError),
  post: (url, data, config) => instance.post(url, data, config).then(handleResponse, handleError),
  put: (url, data, config) => instance.put(url, data, config).then(handleResponse, handleError),
  patch: (url, data, config) => instance.patch(url, data, config).then(handleResponse, handleError),
  delete: (url, data) => instance.delete(url, { data }).then(handleResponse, handleError),
};
